"use strict";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Shortcode = require('./shortcode');

var ShortcodeNode = function () {
  function ShortcodeNode(content) {
    _classCallCheck(this, ShortcodeNode);

    if (content instanceof Shortcode) {
      this.text = content.content;
      this.shortcode = content;
    } else if (content) {
      this.text = content.toString();
      this.shortcode = null;
    } else {
      this.text = null;
      this.shortcode = null;
    }

    this.children = [];
  }

  _createClass(ShortcodeNode, [{
    key: "isRootNode",
    value: function isRootNode() {
      return !this.hasShortcode();
    }
  }, {
    key: "hasShortcode",
    value: function hasShortcode() {
      return this.shortcode != null;
    }
  }, {
    key: "hasText",
    value: function hasText() {
      return this.text != null;
    }
  }, {
    key: "addChild",
    value: function addChild(node) {
      this.children.push(node);
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this.children.length > 0;
    }
  }, {
    key: "traceTree",
    value: function traceTree(level) {
      if (!level) {
        level = 0;
      }

      var fnRepeatChar = function fnRepeatChar(char, level) {
        if (level === 0) {
          return "";
        }

        var chars = "";

        for (var i = 0; i < level * 3; i++) {
          chars += char;
        }

        return chars + " ";
      };

      if (this.isRootNode()) {
        console.log('+++++ Root Node +++++');
        level = 0;
      } else {
        console.log(fnRepeatChar('-', level) + '[Shortcode Node: ' + this.shortcode.name + '], content: ' + this.shortcode.content);
        level++;
      }

      for (var i = 0; i < this.children.length; i++) {
        var childNode = this.children[i];
        childNode.traceTree(level);
      }
    }
  }]);

  return ShortcodeNode;
}();

module.exports = ShortcodeNode;